module.exports = __webpack_public_path__ + "img/trasport-notification.b0dc588a.svg";